import { defineStore } from "pinia";

export const useIsEditStore = defineStore("isEdit", {
  state: () => ({
    isEdit: false,
  }),
  actions: {
    setIsEdit(value) {
      this.isEdit = value;
    },
  },
});
